import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import AdminApp from './AdminApp';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Choose app based on environment
const isAdminMode = process.env.REACT_APP_ADMIN_MODE === 'true';

root.render(
  <React.StrictMode>
    {isAdminMode ? <AdminApp /> : <App />}
  </React.StrictMode>
);

reportWebVitals();